import { render } from "./CondutaEtica.vue?vue&type=template&id=0530d1a0&scoped=true"
import script from "./CondutaEtica.vue?vue&type=script&lang=js"
export * from "./CondutaEtica.vue?vue&type=script&lang=js"

import "./CondutaEtica.vue?vue&type=style&index=0&id=0530d1a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0530d1a0"]])

export default __exports__